module.exports = __webpack_public_path__ + "static/img/assess-bar.39ecef96.png";